import { createSelector } from '@ngrx/store';

import { membersState } from '../root';

export const isDownloadingFreeProducts = createSelector(membersState, (members) => members.freeProducts.isDownloading);
